var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-broken",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M4.451 9.333c2.305-3.985 6.614-6.667 11.55-6.667 7.364 0 13.333 5.97 13.333 13.333s-5.97 13.333-13.333 13.333c-4.935 0-9.244-2.681-11.55-6.667"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M16 21.333l5.333-5.333-5.333-5.333"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M2.667 16h18.667"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-burger",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3529,
    d: "M4 16h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3529,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.3529,
    d: "M4 24h24"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar-check",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M28 13.333h-24M28 16.667v-4.933c0-2.24 0-3.36-0.436-4.216-0.383-0.753-0.995-1.365-1.748-1.748-0.856-0.436-1.976-0.436-4.216-0.436h-11.2c-2.24 0-3.36 0-4.216 0.436-0.753 0.383-1.365 0.995-1.748 1.748-0.436 0.856-0.436 1.976-0.436 4.216v11.2c0 2.24 0 3.36 0.436 4.216 0.383 0.753 0.995 1.365 1.748 1.748 0.856 0.436 1.976 0.436 4.216 0.436h5.6M21.333 2.667v5.333M10.667 2.667v5.333M19.333 25.333l2.667 2.667 6-6"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-down",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "black",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 3.5556,
    d: "M8 12l8 8 8-8"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M20 24l-8-8 8-8"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M12 24l8-8-8-8"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-done",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.133 18.4l-2.9-2.9c-0.244-0.244-0.55-0.361-0.916-0.349s-0.673 0.138-0.917 0.383-0.367 0.556-0.367 0.933c0 0.378 0.122 0.689 0.367 0.933l3.8 3.8c0.244 0.244 0.556 0.367 0.933 0.367s0.689-0.122 0.933-0.367l7.567-7.567c0.244-0.244 0.361-0.55 0.351-0.917s-0.14-0.672-0.384-0.916-0.556-0.367-0.933-0.367c-0.378 0-0.689 0.122-0.933 0.367l-6.6 6.6zM16 29.333c-1.844 0-3.578-0.35-5.2-1.051s-3.033-1.649-4.233-2.849-2.15-2.611-2.849-4.233c-0.7-1.622-1.051-3.356-1.051-5.2s0.35-3.578 1.051-5.2c0.7-1.622 1.649-3.033 2.849-4.233s2.611-2.15 4.233-2.851c1.622-0.7 3.356-1.049 5.2-1.049s3.578 0.35 5.2 1.049c1.622 0.7 3.033 1.651 4.233 2.851s2.15 2.611 2.849 4.233c0.7 1.622 1.051 3.356 1.051 5.2s-0.35 3.578-1.051 5.2c-0.7 1.622-1.649 3.033-2.849 4.233s-2.611 2.15-4.233 2.849c-1.622 0.7-3.356 1.051-5.2 1.051zM16 26.667c2.956 0 5.472-1.039 7.551-3.116s3.116-4.595 3.116-7.551c0-2.956-1.039-5.472-3.116-7.551s-4.595-3.116-7.551-3.116c-2.956 0-5.472 1.039-7.549 3.116s-3.117 4.595-3.117 7.551c0 2.956 1.039 5.472 3.117 7.551s4.594 3.116 7.549 3.116z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-down-arrow-left",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.837 17.050l-1.183-0.805 22.508-0.001v-0.63l-22.366 0.001 1.115-0.641-0.314-0.546-2.566 1.474 2.453 1.668 0.354-0.521z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-down-arrow-right",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.582 14.81l1.183 0.805-22.508 0.001v0.63l22.366-0.001-1.115 0.641 0.314 0.546 2.566-1.474-2.453-1.668-0.354 0.521z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Ellipse",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-error",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.667 20h2.667v2.667h-2.667v-2.667zM14.667 9.333h2.667v8h-2.667v-8zM15.987 2.667c-7.36 0-13.32 5.973-13.32 13.333s5.96 13.333 13.32 13.333c7.373 0 13.347-5.973 13.347-13.333s-5.973-13.333-13.347-13.333zM16 26.667c-5.893 0-10.667-4.773-10.667-10.667s4.773-10.667 10.667-10.667c5.893 0 10.667 4.773 10.667 10.667s-4.773 10.667-10.667 10.667z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-log-in",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.5263,
    d: "M19.789 4.632h1.516c2.122 0 3.183 0 3.994 0.413 0.713 0.363 1.293 0.943 1.656 1.656 0.413 0.811 0.413 1.872 0.413 3.994v10.611c0 2.122 0 3.183-0.413 3.994-0.363 0.713-0.943 1.293-1.656 1.656-0.811 0.413-1.872 0.413-3.994 0.413h-1.516M13.474 9.684l6.316 6.316M19.789 16l-6.316 6.316M19.789 16h-15.158"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-log-out-01",
    viewBox: "0 0 34 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    style: {
      stroke: "var(--color1, #fff)"
    },
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M22.222 22.667l6.667-6.667M28.889 16l-6.667-6.667M28.889 16h-16M12.889 4h-1.6c-2.24 0-3.36 0-4.216 0.436-0.753 0.383-1.365 0.995-1.748 1.748-0.436 0.856-0.436 1.976-0.436 4.216v11.2c0 2.24 0 3.36 0.436 4.216 0.383 0.753 0.995 1.365 1.748 1.748 0.856 0.436 1.976 0.436 4.216 0.436h1.6"
  })), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-moon",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.656 17.393c-0.904 0.24-1.834 0.361-2.769 0.361-2.847 0-5.52-1.107-7.528-3.115-1.319-1.326-2.267-2.975-2.749-4.782s-0.484-3.709-0.002-5.516c0.060-0.226 0.060-0.464-0.001-0.689s-0.18-0.432-0.345-0.597c-0.165-0.165-0.371-0.284-0.597-0.344s-0.464-0.060-0.69 0c-2.262 0.603-4.327 1.79-5.985 3.443-5.197 5.197-5.197 13.657 0 18.857 1.235 1.242 2.705 2.227 4.323 2.898s3.354 1.014 5.106 1.009c1.752 0.005 3.487-0.338 5.105-1.008s3.087-1.655 4.322-2.897c1.654-1.659 2.841-3.724 3.444-5.988 0.060-0.226 0.059-0.463-0.002-0.689s-0.18-0.431-0.345-0.596-0.371-0.284-0.596-0.345c-0.226-0.061-0.463-0.061-0.689-0.001zM23.96 23.128c-0.988 0.993-2.163 1.781-3.458 2.317s-2.682 0.81-4.084 0.807c-1.402 0.003-2.79-0.271-4.085-0.807s-2.471-1.324-3.459-2.318c-4.157-4.159-4.157-10.927 0-15.085 0.803-0.802 1.731-1.47 2.747-1.977-0.149 1.919 0.119 3.847 0.784 5.653s1.712 3.447 3.070 4.811c1.361 1.362 3.002 2.412 4.808 3.077s3.736 0.931 5.656 0.777c-0.51 1.014-1.178 1.941-1.979 2.745z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pencil",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M3.333 28.667l7.399-2.846c0.473-0.182 0.71-0.273 0.931-0.392 0.197-0.106 0.384-0.227 0.56-0.364 0.198-0.154 0.378-0.333 0.736-0.692l15.040-15.040c1.473-1.473 1.473-3.861 0-5.333s-3.861-1.473-5.333 0l-15.040 15.040c-0.359 0.359-0.538 0.538-0.692 0.736-0.137 0.176-0.259 0.364-0.364 0.561-0.119 0.221-0.21 0.458-0.392 0.931l-2.846 7.399zM3.333 28.667l2.744-7.135c0.196-0.511 0.295-0.766 0.463-0.883 0.147-0.102 0.329-0.141 0.505-0.107 0.201 0.038 0.395 0.232 0.782 0.619l3.012 3.012c0.387 0.387 0.58 0.58 0.619 0.782 0.034 0.176-0.005 0.358-0.107 0.505-0.117 0.168-0.372 0.267-0.883 0.463l-7.135 2.744z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus-square",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 6.667v18.667M6.667 16h18.667"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 10.667v10.667M10.667 16h10.667M29.333 16c0 7.364-5.97 13.333-13.333 13.333s-13.333-5.97-13.333-13.333c0-7.364 5.97-13.333 13.333-13.333s13.333 5.97 13.333 13.333z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Star",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 4,
    strokeWidth: 1.7455,
    d: "M16 1.87l4.396 8.332c0.231 0.439 0.653 0.745 1.142 0.83l9.283 1.606-6.566 6.756c-0.346 0.356-0.507 0.852-0.436 1.343l1.341 9.325-8.454-4.157c-0.445-0.219-0.967-0.219-1.412 0l-8.454 4.157 1.341-9.325c0.071-0.491-0.091-0.987-0.436-1.343l-6.566-6.756 9.283-1.606c0.489-0.085 0.911-0.391 1.142-0.83v0l4.396-8.332zM6.592 30.184c0 0 0-0 0-0l-0 0zM16.128 1.627l0-0c0 0-0 0-0 0z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-statistics",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8 9.037c0-0.759 0.001-1.305 0.038-1.732 0.037-0.436 0.103-0.596 0.134-0.648 0.008-0.013 0.011-0.016 0.015-0.019l0.001-0c0.009-0.006 0.045-0.031 0.138-0.060 0.208-0.064 0.569-0.112 1.207-0.112s1 0.048 1.207 0.112c0.093 0.029 0.129 0.053 0.138 0.060l0.001 0c0.004 0.003 0.007 0.005 0.015 0.019 0.031 0.052 0.097 0.212 0.134 0.648 0.037 0.427 0.037 0.973 0.037 1.732v13.926c0 0.896-0.051 1.503-0.135 1.915-0.084 0.414-0.182 0.531-0.199 0.548-0.006 0.006-0.011 0.011-0.029 0.020-0.023 0.011-0.072 0.029-0.169 0.046-0.221 0.038-0.511 0.041-1.002 0.041-0.499 0-0.793-0.003-1.015-0.042-0.097-0.017-0.146-0.035-0.168-0.045-0.016-0.008-0.020-0.012-0.025-0.017-0.015-0.016-0.112-0.131-0.195-0.547-0.082-0.413-0.132-1.022-0.132-1.92v-13.926zM25.333 4.2c-1.288 0-2.612 0.136-3.305 1.291-0.302 0.504-0.403 1.084-0.449 1.621-0.046 0.535-0.046 1.177-0.046 1.884v13.968c0 0.954 0.050 1.734 0.175 2.363 0.125 0.625 0.343 1.205 0.761 1.652 0.439 0.47 0.975 0.664 1.466 0.748 0.435 0.075 0.92 0.074 1.344 0.074h0.107c0.418 0 0.9 0 1.333-0.074 0.489-0.084 1.023-0.278 1.463-0.745 0.42-0.445 0.643-1.023 0.77-1.651 0.128-0.63 0.18-1.412 0.18-2.367v-13.968c0-0.706 0-1.349-0.046-1.884-0.046-0.536-0.147-1.117-0.449-1.621-0.693-1.155-2.017-1.291-3.305-1.291zM14.505 12.667c-0.033 0.301-0.035 0.651-0.035 1.111v9.778c0 0.011-0 0.022-0 0.033-0.033 1.146 0.175 1.533 0.299 1.666 0.107 0.115 0.376 0.279 1.23 0.279 0.834 0 1.112-0.162 1.226-0.283 0.127-0.134 0.34-0.522 0.303-1.658-0-0.012-0.001-0.024-0.001-0.036v-9.778c0-0.461-0.001-0.811-0.035-1.111-0.033-0.296-0.089-0.448-0.137-0.529l-0.002-0.003c-0.031-0.053-0.198-0.335-1.356-0.335s-1.324 0.282-1.356 0.335l-0.002 0.003c-0.049 0.081-0.104 0.232-0.137 0.529zM12.698 10.973c0.639-1.066 1.819-1.44 3.302-1.44s2.663 0.374 3.302 1.44c0.284 0.475 0.395 0.99 0.445 1.444 0.049 0.438 0.049 0.908 0.049 1.328v9.793c0.039 1.301-0.16 2.461-0.921 3.268-0.777 0.823-1.869 0.995-2.875 0.995-1.015 0-2.112-0.169-2.887-0.999-0.754-0.808-0.944-1.97-0.909-3.261v-9.795c-0-0.42-0-0.89 0.049-1.328 0.050-0.454 0.161-0.969 0.445-1.444zM5.169 19.359c-0.035 0.352-0.036 0.776-0.036 1.344v3.689c0 0.641 0.155 0.816 0.23 0.88 0.122 0.103 0.453 0.261 1.303 0.261 0.832 0 1.167-0.156 1.296-0.264 0.081-0.068 0.237-0.247 0.237-0.877v-3.669l-0.009-0.27c-0.015-0.439-0.026-0.782-0.059-1.085-0.039-0.363-0.099-0.533-0.146-0.616l-0.001-0.002c-0.012-0.027-0.127-0.285-1.319-0.285-1.196 0-1.336 0.261-1.355 0.297l-0.001 0.003c-0.046 0.078-0.106 0.242-0.141 0.593zM3.356 17.618c0.654-1.112 1.877-1.418 3.31-1.418 1.436 0 2.648 0.308 3.288 1.431 0.276 0.485 0.379 1.020 0.43 1.495 0.043 0.395 0.057 0.841 0.072 1.281 0.003 0.086 0.006 0.172 0.009 0.257l0 0.013 0 0.027v3.689c0 0.991-0.256 1.949-1.047 2.613-0.744 0.624-1.741 0.795-2.753 0.795-1.021 0-2.024-0.169-2.767-0.798-0.79-0.669-1.033-1.63-1.033-2.61v-3.725c-0-0.522-0-1.056 0.047-1.532 0.048-0.487 0.155-1.029 0.442-1.517z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sun",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.324 16c0 3.681 2.995 6.676 6.676 6.676s6.676-2.995 6.676-6.676c0-3.681-2.995-6.676-6.676-6.676s-6.676 2.995-6.676 6.676zM16 11.991c2.211 0 4.009 1.799 4.009 4.009s-1.799 4.009-4.009 4.009c-2.211 0-4.009-1.799-4.009-4.009s1.799-4.009 4.009-4.009zM14.664 25.333h2.667v4h-2.667v-4zM14.664 2.667h2.667v4h-2.667v-4zM2.664 14.667h4v2.667h-4v-2.667zM25.331 14.667h4v2.667h-4v-2.667zM5.625 24.484l2.827-2.829 1.887 1.885-2.827 2.829-1.887-1.885zM21.653 8.459l2.829-2.829 1.885 1.885-2.829 2.829-1.885-1.885zM8.456 10.345l-2.829-2.829 1.887-1.885 2.827 2.829-1.884 1.885zM26.368 24.485l-1.885 1.885-2.829-2.829 1.885-1.885 2.829 2.829z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M12 4h8"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M4 8h24"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M6.667 8l0.801 12.018c0.149 2.231 0.223 3.347 0.588 4.243 0.662 1.627 2.004 2.883 3.672 3.435 0.919 0.304 2.037 0.304 4.273 0.304v0c2.236 0 3.354 0 4.273-0.304 1.668-0.552 3.009-1.808 3.671-3.435 0.365-0.896 0.439-2.012 0.588-4.243l0.801-12.018"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user-check",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M21.333 24l2.667 2.667 5.333-5.333"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M16 20.667h-6c-1.861 0-2.791 0-3.548 0.23-1.705 0.517-3.038 1.851-3.555 3.556-0.23 0.757-0.23 1.687-0.23 3.548v0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M13.333 16c3.314 0 6-2.686 6-6s-2.686-6-6-6c-3.314 0-6 2.686-6 6s2.686 6 6 6z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.865 26.5c-1.904-3.291-4.838-5.651-8.261-6.77 1.694-1.008 3.009-2.544 3.745-4.373s0.851-3.848 0.329-5.748c-0.523-1.9-1.655-3.576-3.223-4.771s-3.484-1.842-5.455-1.842c-1.971 0-3.887 0.647-5.455 1.842s-2.7 2.871-3.223 4.771-0.407 3.92 0.329 5.748c0.736 1.828 2.052 3.365 3.745 4.373-3.424 1.118-6.358 3.478-8.261 6.77-0.070 0.114-0.116 0.241-0.136 0.373s-0.014 0.267 0.019 0.396c0.033 0.129 0.091 0.251 0.172 0.358s0.182 0.196 0.297 0.263 0.243 0.11 0.376 0.126c0.132 0.017 0.267 0.006 0.396-0.030s0.248-0.098 0.353-0.181c0.104-0.083 0.191-0.187 0.255-0.304 2.355-4.070 6.517-6.5 11.134-6.5s8.779 2.43 11.134 6.5c0.064 0.117 0.15 0.221 0.255 0.304s0.224 0.145 0.353 0.181c0.129 0.036 0.263 0.046 0.396 0.030s0.26-0.060 0.376-0.126c0.116-0.067 0.217-0.156 0.297-0.263s0.139-0.228 0.172-0.358c0.033-0.129 0.039-0.264 0.019-0.396s-0.066-0.259-0.136-0.373zM9 12c0-1.384 0.411-2.738 1.18-3.889s1.862-2.048 3.142-2.578 2.687-0.668 4.044-0.398c1.358 0.27 2.605 0.937 3.584 1.916s1.646 2.226 1.916 3.584c0.27 1.358 0.131 2.765-0.398 4.044s-1.427 2.372-2.578 3.141c-1.151 0.769-2.505 1.18-3.889 1.18-1.856-0.002-3.635-0.74-4.948-2.052s-2.050-3.092-2.052-4.948z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-x-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M24 8l-16 16"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6667,
    d: "M8 8l16 16"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-enter",
    viewBox: "0 0 15 15"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.75 0.75H10.65C11.9101 0.75 12.5402 0.75 13.0215 0.995235C13.4448 1.21095 13.789 1.55516 14.0048 1.97852C14.25 2.45982 14.25 3.08988 14.25 4.35V10.65C14.25 11.9101 14.25 12.5402 14.0048 13.0215C13.789 13.4448 13.4448 13.789 13.0215 14.0048C12.5402 14.25 11.9101 14.25 10.65 14.25H9.75M6 3.75L9.75 7.5M9.75 7.5L6 11.25M9.75 7.5L0.75 7.5"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash-2",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 7v13c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-10c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-13zM17 5v-1c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879h-4c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v1h-4c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v13c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h10c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-13h1c0.552 0 1-0.448 1-1s-0.448-1-1-1zM9 5v-1c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293h4c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707v1zM9 11v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1zM13 11v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pencil",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 4,
    strokeWidth: 2.6,
    d: "M3.333 28.667l7.399-2.846c0.473-0.182 0.71-0.273 0.931-0.392 0.197-0.106 0.384-0.227 0.56-0.364 0.198-0.154 0.378-0.333 0.736-0.692l15.040-15.040c1.473-1.473 1.473-3.861 0-5.333s-3.861-1.473-5.333 0l-15.040 15.040c-0.359 0.359-0.538 0.538-0.692 0.736-0.137 0.176-0.259 0.364-0.364 0.561-0.119 0.221-0.21 0.458-0.392 0.931l-2.846 7.399zM3.333 28.667l2.744-7.135c0.196-0.511 0.295-0.766 0.463-0.883 0.147-0.102 0.329-0.141 0.505-0.107 0.201 0.038 0.395 0.232 0.782 0.619l3.012 3.012c0.387 0.387 0.58 0.58 0.619 0.782 0.034 0.176-0.005 0.358-0.107 0.505-0.117 0.168-0.372 0.267-0.883 0.463l-7.135 2.744z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.5872019dcfa18bca9e74a8b221072101.svg";
export { ForwardRef as ReactComponent };